/*eslint-disable no-undef*/
import debounce from 'lodash/debounce';
import { BLOG_SECTION_ID, BLOG_FEED_PATH, ROOT_ELEMENT_SELECTOR, SVG_ICON_SELECTOR } from './constants/app';
import { feedButtonByBackgroundId } from './feed-buttons';
import { appLoaded } from './services/fedops-logger';
import { getBackgroundTypeId } from '../rss-feed-widget-settings/selectors/app-settings-selectors';

function createBlogUrlGetter() {
  const urls = {};

  return {
    getBlogUrlForPath(path, cb) {
      if (urls[path]) {
        return cb(urls[path]);
      } else {
        Wix.getStateUrl(BLOG_SECTION_ID, path, ({ url }) => {
          urls[path] = url;
          return cb(url);
        });
      }
    },
  };
}

function ensureIframeSizeMatchesContent() {
  const resizeDebounced = debounce(() => {
    const el = document.querySelector(SVG_ICON_SELECTOR);
    if (el) {
      const { height } = el.getBoundingClientRect();
      Wix.setHeight(height);
    }
  }, 20);

  window.addEventListener('resize', resizeDebounced);
}

function getWidgetBackgroundStyleId(style) {
  return getBackgroundTypeId({ style });
}

function renderWithLink(href, children) {
  return `<a href="${href}" target="_blank">${children}</a>`;
}

function renderIntoContainer(content) {
  const root = document.querySelector(ROOT_ELEMENT_SELECTOR);
  root.innerHTML = content;
}

function renderWidget(styles, getBlogUrlForPath) {
  const feedButton = feedButtonByBackgroundId[getWidgetBackgroundStyleId(styles)];

  getBlogUrlForPath(BLOG_FEED_PATH, linkToFeed => {
    renderIntoContainer(
      renderWithLink(linkToFeed, feedButton)
    );

    appLoaded();
  });
}

export function init() {
  const { getBlogUrlForPath } = createBlogUrlGetter();
  const renderByBackgroundStyle = styles => {
    renderWidget(styles, getBlogUrlForPath);
  };

  Wix.Styles.getStyleParams(renderByBackgroundStyle);
  Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, renderByBackgroundStyle);
  ensureIframeSizeMatchesContent();
}



// WEBPACK FOOTER //
// ./rss-feed-widget/app.js